"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function TeamsGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__teams-grey-outline__clip0_18228_5363)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.908 6.944H12.01a.48.48 0 00-.24.064.485.485 0 00-.25.422v.128c.06.02.105.08.105.149v4.347s0 .036-.004.056c.1.297.28.554.51.747.156.14.337.245.533.317.189.072.398.112.61.112h.37c.967 0 1.754-.786 1.754-1.754V7.43a.488.488 0 00-.49-.486zm-.112 4.588c0 .634-.518 1.152-1.152 1.152h-.37c-.172 0-.333-.036-.481-.108.024-.173.036-.345.036-.522V7.707c0-.052-.004-.109-.012-.16h1.979v3.985z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M14.908 6.342H12.01a1.04 1.04 0 00-.253.032 1.073 1.073 0 00-.722.57 1.11 1.11 0 00-.117.486v.116h.546c.02 0 .036.004.056.012.06.02.105.08.105.149v4.347s0 .036-.004.056a2.605 2.605 0 01-.173.908 2.333 2.333 0 001.826.87h.37c1.3 0 2.356-1.055 2.356-2.356V7.43c0-.598-.49-1.088-1.092-1.088zm-.112 5.19c0 .634-.518 1.152-1.152 1.152h-.37c-.172 0-.333-.036-.481-.108a1.135 1.135 0 01-.566-.57 1.106 1.106 0 01-.105-.474V7.546h2.674v3.986z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.702.602a2.115 2.115 0 00-2.11 2.115c0 .12.007.237.031.35.032.216.1.417.197.602.112.229.269.433.457.606h.004a2.003 2.003 0 00.719.43c.189.072.393.112.602.12a2.112 2.112 0 10.1-4.223zm0 3.625c-.04 0-.08 0-.116-.008a1.334 1.334 0 00-1.32-1.152h-.029a1.263 1.263 0 01-.044-.35c0-.834.679-1.513 1.51-1.513.83 0 1.513.679 1.513 1.513 0 .835-.679 1.51-1.514 1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.703 0a2.719 2.719 0 00-2.714 2.718c0 .116.008.236.028.349.02.208.072.413.145.602.08.217.188.417.32.602h.783s.009 0 .013.004h.004c.036.036.072.068.108.096.008.012.008.02.008.032v.69c.189.105.39.19.602.242a2.3 2.3 0 00.602.092 2.719 2.719 0 002.818-2.71A2.722 2.722 0 008.703 0zm0 4.227c-.04 0-.08 0-.117-.008a1.47 1.47 0 01-.975-.462 1.436 1.436 0 01-.374-.69 1.263 1.263 0 01-.044-.35c0-.834.679-1.513 1.51-1.513a1.511 1.511 0 110 3.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.636 2.011a1.41 1.41 0 00-1.41 1.409c0 .775.63 1.409 1.41 1.409a1.408 1.408 0 100-2.818zm0 2.216a.807.807 0 110-1.614.807.807 0 010 1.614z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M13.636 1.409a2.015 2.015 0 00-2.011 2.011c0 1.108.903 2.011 2.01 2.011a2.012 2.012 0 000-4.022zm0 2.818a.807.807 0 110-1.614.807.807 0 010 1.614z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.207 7.546a.747.747 0 00-.438-.538.768.768 0 00-.305-.064H7.398v3.388c0 .072-.06.132-.133.132H4.83v1.59a3.344 3.344 0 003.344 3.344h.71a3.344 3.344 0 003.344-3.344V7.707a.536.536 0 00-.02-.16zm-3.324 7.25h-.71a2.745 2.745 0 01-2.742-2.742v-.385h1.834c.739 0 1.337-.598 1.337-1.337V7.546h2.862c.02 0 .036.004.056.012.06.02.105.08.105.149v4.347s0 .036-.004.056a2.74 2.74 0 01-2.738 2.685z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M4.227 7.707v1.75H4.7V6.675a1.345 1.345 0 00-.473 1.032zm8.59-.16c-.024-.221-.1-.426-.22-.603a1.364 1.364 0 00-1.133-.602H7.398v1.204h4.066c.02 0 .036.004.056.012.06.02.105.08.105.149v4.347s0 .036-.004.056a2.74 2.74 0 01-2.738 2.685h-.71a2.745 2.745 0 01-2.742-2.74v-1.59H4.227v1.59A3.95 3.95 0 008.173 16h.71a3.957 3.957 0 003.569-2.26c.084-.18.156-.37.212-.566.06-.193.105-.393.129-.598.024-.173.036-.345.036-.522V7.707c0-.052-.004-.108-.012-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.61 5.295v.678h1.276v3.484H4.7V5.973h1.28v-.678H2.61zm0 0v.678h1.276v3.484H4.7V5.973h1.28v-.678H2.61zm0 0v.678h1.276v3.484H4.7V5.973h1.28v-.678H2.61zm0 0v.678h1.276v3.484H4.7V5.973h1.28v-.678H2.61zm0 0v.678h1.276v3.484H4.7V5.973h1.28v-.678H2.61zm0 0v.678h1.276v3.484H4.7V5.973h1.28v-.678H2.61zm0 0v.678h1.276v3.484H4.7V5.973h1.28v-.678H2.61zm0 0v.678h1.276v3.484H4.7V5.973h1.28v-.678H2.61zm5.237-1.333a.65.65 0 00-.236-.205.723.723 0 00-.346-.088H1.337a.735.735 0 00-.735.734v5.93c0 .405.33.734.735.734h5.928c.406 0 .735-.33.735-.735V4.403a.718.718 0 00-.153-.441zm-.45.441v5.93c0 .071-.06.132-.132.132H1.337a.134.134 0 01-.133-.133V4.403c0-.072.06-.132.133-.132h5.928s.008 0 .012.004h.004c.037.036.073.068.109.096.008.012.008.02.008.032zM2.61 5.973h1.277v3.484H4.7V5.973h1.28v-.678H2.61v.678zm0-.678v.678h1.277v3.484H4.7V5.973h1.28v-.678H2.61zm0 0v.678h1.277v3.484H4.7V5.973h1.28v-.678H2.61zm0 0v.678h1.277v3.484H4.7V5.973h1.28v-.678H2.61zm0 0v.678h1.277v3.484H4.7V5.973h1.28v-.678H2.61zm0 0v.678h1.277v3.484H4.7V5.973h1.28v-.678H2.61zm0 0v.678h1.277v3.484H4.7V5.973h1.28v-.678H2.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.586 4.219a1.334 1.334 0 00-1.32-1.152h-5.93C.599 3.067 0 3.665 0 4.403v5.93c0 .738.598 1.336 1.337 1.336h5.928c.739 0 1.337-.598 1.337-1.337V4.403c0-.064 0-.124-.016-.184zm-1.188.184v5.93c0 .072-.06.132-.133.132H1.337a.134.134 0 01-.133-.133V4.403c0-.072.06-.132.133-.132h5.928s.008 0 .012.004h.004c.057.004.1.044.109.096.008.012.008.02.008.032z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M5.98 5.295v.678H4.7v3.484h-.814V5.973H2.609v-.678h3.372z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__teams-grey-outline__clip0_18228_5363"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

TeamsGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
TeamsGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = TeamsGreyOutline;
exports["default"] = _default;